import { Redirect } from "@shopify/app-bridge/actions"
import { AdminSectionPayload, Section } from "@shopify/app-bridge/actions/Navigation/Redirect"
import { isShopifyEmbedded } from "@shopify/app-bridge-utils"

import stores from "@/stores"
import AppBridge from "@/utils/appBridge"
import toast from "@/utils/toast"

const redirectAdminSection = (payload: Section | AdminSectionPayload) => {
  if (!window.isFromAdmin && isShopifyEmbedded()) {
    const redirect = Redirect.create(AppBridge.app)

    redirect.dispatch(Redirect.Action.ADMIN_SECTION, payload)
  } else {
    toast("Cannot be redirected in a non-Shopify environment", 2000, true)
  }
}

/**
 * 打开新链接
 * @param url
 */
export const openLink = (url: string, notShopifyUrl?: string) => {
  if (!window.isFromAdmin && isShopifyEmbedded()) {
    AppBridge.redirect && AppBridge.redirect.dispatch(Redirect.Action.REMOTE, {
      url,
      newContext: true,
    })
  } else {
    window.open(notShopifyUrl || url)
  }
}

/**
 * 进入Checkout edit order status page
 * @param id
 */
export const navigateToCheckoutStatusPage = (id: string | number) => {
  const { userInfoSore } = stores
  const shopName = userInfoSore.data.store_name.replace(".myshopify.com", "")

  const query = "?page=order-status&context=extensibility&extensionPicker=true"

  openLink(`https://admin.shopify.com/settings/checkout/editor/profiles/${id}${query}`,
    `https://admin.shopify.com/store/${shopName}/settings/checkout/editor/profiles/${id}${query}`)
  return true
}

/**
 * Open Checkout & Accounts editor on customer account order index page
 * to add Protection - order action extension.
 */
export const navigateToCustomerAccountOrderAction = (
  checkoutProfileId: string | number,
  extensionUid?: string,
) => {
  const { userInfoSore } = stores
  const shopName = userInfoSore.data.store_name.replace(".myshopify.com", "")

  const params = new URLSearchParams({
    page: "order-status",
    context: "extensibility",
    extensionPicker: "true",
  })

  if (extensionUid) {
    params.set("config_panel_extension", extensionUid)
  }

  const query = `?${params.toString()}`
  const basePath = `/settings/checkout/editor/profiles/${checkoutProfileId}${query}`

  openLink(
    `https://admin.shopify.com/store/${shopName}${basePath}`,
    `https://admin.shopify.com/store/${shopName}${basePath}`,
  )
  return true
}
/**
 * 新标签页打开 Shopify 后台页面
 * 地址必须带 /store/{店铺名}，不带店铺的 https://admin.shopify.com/orders/:id 会被 Shopify 先重定向一次
 * @param path 后台路径，如 orders/123
 */
const openAdminPage = (path: string) => {
  const shopName = stores.userInfoSore.data.store_name.replace(".myshopify.com", "")
  const url = `https://admin.shopify.com/store/${shopName}/${path}`

  openLink(url, url)
}

/**
 * 通过订单id 重定向到Shopify Order详情页面
 * @param id
 */
export const navigateToOrderById = (id: string) => {
  openAdminPage(`orders/${id}`)
  return true
}
/**
 * 通过订单id 重定向到Shopify Customer详情页面
 * @param id
 */
export const navigateToCustomerById = (id: string) => {
  openAdminPage(`customers/${id}`)
  return true
}

/**
 * 通过订单id 重定向到Shopify 指定Id Product页面
 * @param id
 */
export const navigateToProductById = (id: string) => {
  redirectAdminSection({
    name: Redirect.ResourceType.Product,
    resource: { id },
    newContext: true,
  })
  return true
}
